import React, { useEffect, memo, useState } from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import Layout from '../../../components/Layout';
import { getListOPDPerjanjianKinerja_act } from "../../../../redux/ducks/cpk/actions"
import BackButton from '../../../components/BackButton';
import ListOpdSakip from './ListOpdSakip';
import ListOpdSakinah from './ListOpdSakinah';
import { useParams } from 'react-router-dom';

const ListOpd_CapaianPK = (props) => {
    const { yearconfig } = useParams()
    useEffect(() => {
      props.getListOPDPerjanjianKinerja(yearconfig)
    },[])
    const breadCrumbsData = [
        {
          title: 'Home',
          isActive: true,
          goTo: '/tahun/'+yearconfig,
        },
        {
          title: `Capaian Perjanjian Kinerja Esselon II`,
          isActive: false,
          goTo: '',
        },
    ];
  return (
    <Layout
      loading={false}
      breadCrumbsData={breadCrumbsData}
    >
      <div
        className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
      >
          <div className="flex-grow bg-white rounded-xl py-2 relative">
            <h1 className="text-lg font-bold text-center">Capaian Perjanjian Kinerja Esselon II</h1>
            <h1 className="mb-1 text-sm text-gray-400 text-center">
              pilih OPD di bawah untuk melihat Capaian Perjanjian Kinerja Esselon II
            </h1>
            <hr className="mb-3" />
          </div>
          {yearconfig > 2025 ? <ListOpdSakinah dataListOpd={props.listOpd.data} yearconfig={yearconfig} loading={props.listOpd.loading} /> : <ListOpdSakip dataListOpd={props.listOpd.data} yearconfig={yearconfig} />}
      </div>
      <BackButton backLink={'/tahun/'+yearconfig} />
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  listOpd: state.pkState.listOPD
})

const mapDispatchToProps = {
    getListOPDPerjanjianKinerja: getListOPDPerjanjianKinerja_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect,memo)(ListOpd_CapaianPK)